/* import __COLOCATED_TEMPLATE__ from './link-card-modal-web-sdk.hbs'; */
var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { camelize } from '@ember/string';
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { APP_ID, LOCATION_ID } from '@banking/ui/utils/checking/payment-form-config';
import { v4 as uuid } from 'uuid';
import { LinkCardResponse } from '@square/dashboard-protos/models/squareup/instant-deposit/instant_deposits';
import { Country } from '@square/dashboard-protos/models/squareup/common/countries';
import { validatePresence } from 'ember-changeset-validations/validators';
import lookupValidator from 'ember-changeset-validations';
import { Changeset } from 'ember-changeset';
import { tracked } from '@glimmer/tracking';
import { debitCardLinkingCdpEvent, Action, Target } from '@banking/ui/utils/checking/debit-card-cdp-events';
import { AuthzEngines, AuthzEnginesManager } from '@square/authz-engines';
import { getCsrfToken } from '@square/dashboard-utilities/utils/csrf';
import { PolicyProtectedAction } from '@square/ember-multipass-components/models/squareup/authz_engines/authz_engines_service';
const VERIFICATION_DETAILS_INTENT_STORE = 'STORE';
export let TokenStatus = /*#__PURE__*/function (TokenStatus) {
  TokenStatus["OK"] = "OK";
  TokenStatus["INVALID"] = "Invalid";
  return TokenStatus;
}({});
function getValidations(intl) {
  return {
    cardholderName: validatePresence({
      presence: true,
      message: intl.t('banking.checking.linkCardModal.validation.cardholderName')
    })
  };
}
let LinkCardModal = (_dec = computed('intl'), (_class = class LinkCardModal extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "checkingCardApi", _descriptor2, this);
    _initializerDefineProperty(this, "events", _descriptor3, this);
    _initializerDefineProperty(this, "userInfo", _descriptor4, this);
    _initializerDefineProperty(this, "modal", _descriptor5, this);
    _initializerDefineProperty(this, "webPaymentsSdk", _descriptor6, this);
    _initializerDefineProperty(this, "emberMultipassConfig", _descriptor7, this);
    _initializerDefineProperty(this, "webSdkCardPaymentMethod", _descriptor8, this);
    _initializerDefineProperty(this, "isSaving", _descriptor9, this);
    _initializerDefineProperty(this, "isLoadingWebSdk", _descriptor10, this);
    _initializerDefineProperty(this, "nameOnCard", _descriptor11, this);
    _initializerDefineProperty(this, "errorMessage", _descriptor12, this);
    _initializerDefineProperty(this, "showLinkCardModal", _descriptor13, this);
  }
  async initiateForm() {
    this.isLoadingWebSdk = true;
    try {
      const card = await this.webPaymentsSdk.initiateForm({
        appId: APP_ID,
        locationId: LOCATION_ID,
        style: {},
        languageCode: this.userInfo.countryCode
      });
      this.webSdkCardPaymentMethod = card;
      this.isLoadingWebSdk = false;
    } catch {
      this.errorMessage = this.intl.t('common.serverError');
    }
  }
  async submitForm() {
    const verificationDetails = {
      intent: VERIFICATION_DETAILS_INTENT_STORE,
      billingContact: {
        givenName: this.nameOnCard
      }
    };
    try {
      // 1. tokenize to get the token from web sdk
      const tokenResult = await this.webSdkCardPaymentMethod.tokenize();
      let token;
      if (tokenResult.status === TokenStatus.OK && tokenResult.token !== undefined) {
        token = tokenResult.token;
      } else if (tokenResult.status === TokenStatus.INVALID) {
        this.errorMessage = this.intl.t('banking.checking.linkCardModal.errors.invalidInput');
        return;
      } else {
        throw new Error(`Tokenization errors: ${JSON.stringify(tokenResult.errors)}`);
      }
      // 2. use the verificationResults & token to verify buyer
      const verificationResults = await this.verifyBuyer(token, verificationDetails);
      // 3. if verified, then we link_card
      await this.linkCard(token, verificationResults);
    } catch {
      this.errorMessageFor();
    } finally {
      this.isSaving = false;
    }
  }
  async verifyBuyer(token, verificationDetails) {
    try {
      const verificationResults = await this.webPaymentsSdk.verifyBuyer({
        source: token,
        details: verificationDetails
      });
      return verificationResults.token;
    } catch (e) {
      throw new Error(`VerifyBuyer Error: ${e})}`);
    }
  }
  async linkCard(cardNonce, verificationToken) {
    const linkCardAction = () => this.checkingCardApi.client.linkCard({
      idempotenceKey: uuid(),
      unitToken: this.args.modalOptions?.currentUnitToken,
      merchantToken: this.args.modalOptions?.merchantToken,
      cardNonceData: {
        cardNonce,
        verificationToken,
        applicationId: APP_ID
      }
    });
    try {
      const linkCardResponse = await linkCardAction();
      const isLinkCardSuccess = [LinkCardResponse.State.LINKED, LinkCardResponse.State.VERIFICATION_PENDING].includes(linkCardResponse?.state);
      if (isLinkCardSuccess) {
        const cardLinkVerificationPending = linkCardResponse.state === LinkCardResponse.State.VERIFICATION_PENDING;
        if (cardLinkVerificationPending) {
          this.trackLinkCardEmailSentEvent();
        } else {
          this.trackLinkCardSuccessEvent();
        }
        this.restoreScroll();
        this.args.close({
          cardLinkSuccess: true,
          cardLinkVerificationPending,
          reopenModal: false
        });
      } else {
        const state = Object.keys(LinkCardResponse.State)[linkCardResponse?.state];
        this.errorMessageFor(state);
      }
    } catch {
      this.errorMessageFor();
    } finally {
      this.isSaving = false;
    }
  }
  get helpText() {
    if (Country[this.userInfo.countryCode] === Country.CA) {
      return this.intl.t('banking.checking.linkCardModal.helpTextCA');
    }
    if (this.args.modalOptions.fromBankLinking) {
      return this.intl.t('banking.checking.linkCardModal.helpTextBankLinkingSdt');
    }

    // Includes isFlexibleTransferUnifiedLinkBankAccountFlow and all other cases.
    return this.intl.t('banking.checking.linkCardModal.helpTextFlexibleTransfersFlow');
  }
  get changeset() {
    const validations = getValidations(this.intl);
    return Changeset({}, lookupValidator(validations), validations, {
      // This option prevents auto-validating as the user types.
      // Instead validating will happen when the user clicks "save".
      skipValidate: true
    });
  }
  errorMessageFor(state = 'generic') {
    const stateAsKey = camelize(state.toLowerCase());
    let key = 'banking.checking.linkCardModal.errors.generic';
    const fullErrorKey = `banking.checking.linkCardModal.errors.${stateAsKey}`;
    if (this.intl.exists(fullErrorKey, this.intl.locales)) {
      key = fullErrorKey;
    }
    this.trackLinkCardErrorEvent(stateAsKey);
    this.errorMessage = this.intl.t(key);
  }
  trackLinkCardErrorEvent(error) {
    this.events.track({
      kind: 'CDP',
      event: debitCardLinkingCdpEvent({
        action: Action.View,
        applet: this.args.modalOptions.cdpApplet,
        target: Target.Error,
        error_type: error
      })
    });
  }
  trackLinkCardAttemptEvent() {
    this.events.track({
      kind: 'CDP',
      event: debitCardLinkingCdpEvent({
        action: Action.Click,
        applet: this.args.modalOptions.cdpApplet,
        target: Target.Confirm
      })
    });
  }
  trackLinkCardCancelEvent() {
    this.events.track({
      kind: 'CDP',
      event: debitCardLinkingCdpEvent({
        action: Action.Click,
        applet: this.args.modalOptions.cdpApplet,
        target: Target.Cancel
      })
    });
  }
  trackLinkCardEmailSentEvent() {
    this.events.track({
      kind: 'CDP',
      event: debitCardLinkingCdpEvent({
        action: Action.View,
        applet: this.args.modalOptions.cdpApplet,
        target: Target.CheckEmail
      })
    });
  }
  trackLinkCardSuccessEvent() {
    this.events.track({
      kind: 'CDP',
      event: debitCardLinkingCdpEvent({
        action: Action.View,
        applet: this.args.modalOptions.cdpApplet,
        target: Target.DebitCardAdded
      })
    });
  }
  trackAzeUnauthEvent() {
    this.events.track({
      kind: 'CDP',
      event: debitCardLinkingCdpEvent({
        action: Action.View,
        applet: this.args.modalOptions.cdpApplet,
        target: Target.AzeUnauth
      })
    });
  }
  restoreScroll() {
    document.body.classList.remove('no-scroll');
  }
  async checkStepUpAuthStatusAndInitForm() {
    try {
      await AuthzEnginesManager.precheckAndPopulateUI({
        env: this.emberMultipassConfig.environment,
        precheckReqBody: {
          action: PolicyProtectedAction.LINK_DEBIT_CARD
        },
        precheckReqExtraHeaders: {
          'x-csrf-token': getCsrfToken()
        },
        onUnauth: () => {
          this.trackAzeUnauthEvent();
        }
      });
      this.showLinkCardModal = true;
    } catch (e) {
      const errorMsg = e.message;
      this.restoreScroll();
      this.args.close({
        cardLinkSuccess: false,
        reopenModal: false
      });
      if (errorMsg !== AuthzEngines.ClientError.ABORTED) {
        throw e;
      }
    }
    await this.initiateForm();
  }
  initLinkCardModal() {
    this.events.track({
      kind: 'CDP',
      event: debitCardLinkingCdpEvent({
        action: Action.View,
        applet: this.args.modalOptions.cdpApplet,
        target: Target.Screen,
        referrer: this.args.modalOptions.referrer
      })
    });
  }
  confirm() {
    this.trackLinkCardAttemptEvent();
    // validate the name prior submit the form
    this.changeset.validate();
    if (this.changeset.isInvalid) {
      this.errorMessage = this.changeset.error.cardholderName.validation.toString();
      return;
    }
    this.isSaving = true;
    this.submitForm();
    this.errorMessage = '';
  }
  updateName({
    detail
  }) {
    this.errorMessage = '';
    this.nameOnCard = detail.value;
    this.changeset.set('cardholderName', detail.value);
  }
  async closeModal() {
    this.restoreScroll();
    if (this.args.modalOptions.fromBankLinking) {
      try {
        // eslint-disable-next-line dashboard/require-modal-open-component
        const confirmContinue = await this.modal.open('sdt-debit-card-prompt', {
          isFlexibleTransferUnifiedLinkBankAccountFlow: this.args.modalOptions.isFlexibleTransferUnifiedLinkBankAccountFlow
        });
        if (confirmContinue) {
          this.args.close({
            cardLinkSuccess: false,
            reopenModal: true
          });
          return true;
        }
      } catch {
        this.trackLinkCardCancelEvent();
        return false;
      }
    }
    this.trackLinkCardCancelEvent();
    this.args.close({
      cardLinkSuccess: false,
      reopenModal: false
    });
    return false;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "checkingCardApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "events", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "modal", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "webPaymentsSdk", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "emberMultipassConfig", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "webSdkCardPaymentMethod", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "isSaving", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "isLoadingWebSdk", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "nameOnCard", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "errorMessage", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "showLinkCardModal", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "changeset", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "changeset"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "checkStepUpAuthStatusAndInitForm", [action], Object.getOwnPropertyDescriptor(_class.prototype, "checkStepUpAuthStatusAndInitForm"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "initLinkCardModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "initLinkCardModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "confirm", [action], Object.getOwnPropertyDescriptor(_class.prototype, "confirm"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateName", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeModal"), _class.prototype)), _class));
export { LinkCardModal as default };